import { Search } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import Input from '@mui/material/Input'
import InputAdornment from '@mui/material/InputAdornment'
import Typography from '@mui/material/Typography'
import WorkersAccordion from 'features/workers/components/WorkersAccordion'
import useFetchWorkers from 'features/workers/hooks/useFetchWorkers'
import { useEffect, useState } from 'react'
import WorkersAccordionSkeleton from '../components/WorkersAccordionSkeleton'

const Workers = () => {
  const [workers, setWorkers] = useState([])
  const [fullWorkers, setFullWorkers] = useState([])
  const [actions, setActions] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const { response, loading, error } = useFetchWorkers()

  useEffect(() => {
    if (response && !loading) {
      setWorkers(response.workers)
      setFullWorkers(response.workers)
      setActions(response.actions)
    }
  }, [response, loading])

  const hideWorkers = (w) => {
    for (let i = 0; i < w.employees.length; i++) {
      const fullName =
        `${w.employees[i].nombre} ${w.employees[i].primer_apellido} ${w.employees[i].segundo_apellido}`.toLowerCase()
      if (!searchTerm) {
        w.employees[i]['hide'] = false
        continue
      }
      if (
        !fullName.includes(searchTerm.toLowerCase()) &&
        !w.employees[i].dni.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !w.employees[i].code_trabajador.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        w.employees[i]['hide'] = true
      } else {
        w.employees[i]['hide'] = false
      }
    }
    if (w.children) {
      for (let i = 0; i < w.children.length; i++) {
        w.children[i] = hideWorkers(w.children[i])
      }
    }
    return w
  }

  const handleSearch = () => {
    const filteredWorkers = fullWorkers.map((worker) => hideWorkers(worker))
    setWorkers(filteredWorkers)
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <>
      {error ? (
        <Typography>No se ha podido realizar la consulta</Typography>
      ) : loading ? (
        <WorkersAccordionSkeleton />
      ) : (
        <>
          <Input
            id="buscador"
            type="text"
            sx={{ mb: 2 }}
            placeholder="Buscar trabajador por nombre, apellidos o DNI"
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="Buscar trabajador" onClick={handleSearch}>
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <WorkersAccordion workers={workers} actions={actions} />
        </>
      )}
    </>
  )
}

export default Workers
